import { Flex, Heading, IconButton } from '@podiumhq/design-system';

import PodiumLogoIcon from 'components/PodiumLogo/PodiumLogoIcon';

export const CheckoutPageHeader = ({ closeCheckoutPage }) => (
  <Flex
    align="center"
    backgroundColor="silver.lightest"
    borderBottom="1px solid"
    borderColor="silver.base"
    height="88px"
    justify="space-between"
    left="0"
    padding="24px"
    position="fixed"
    right="0"
    top="-0"
  >
    <Flex>
      <PodiumLogoIcon
        backgroundColor="silver.lightest"
        iconProps={{ boxSize: 6, color: 'black.base' }}
        mr="28px"
      />

      <Heading fontSize="2xl" fontWeight="semibold">
        Checkout
      </Heading>
    </Flex>

    {closeCheckoutPage && (
      <IconButton
        color="grey.lighter"
        onClick={closeCheckoutPage}
        type="XClose"
        variant="ghost"
      />
    )}
  </Flex>
);
